export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const ADD_NEW_USER = "ADD_NEW_USER";
export const GET_USER = "GET_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const ADD_TO_CART = "ADD_TO_CART";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
